import { render, staticRenderFns } from "./create-password-forgot.vue?vue&type=template&id=4f6a2df2&"
import script from "./create-password-forgot.vue?vue&type=script&lang=js&"
export * from "./create-password-forgot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports